import React, { useRef, useEffect } from 'react';
import { useNotify } from 'react-admin';
import SignaturePad from 'signature_pad';

const SignaturePadComponent = ({setSignatureImage}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const signaturePadRef = useRef<SignaturePad | null>(null);
  const notify = useNotify();

  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas) {
      signaturePadRef.current = new SignaturePad(canvas);

      // Resize the canvas to fill the container
      resizeCanvas();
      window.addEventListener('resize', resizeCanvas);

      return () => {
        window.removeEventListener('resize', resizeCanvas);
      };
    }
  }, []);

  const resizeCanvas = () => {
    const canvas = canvasRef.current;
    if (canvas) {
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext('2d')?.scale(ratio, ratio);
    }
  };

  const handleClear = () => {
    signaturePadRef.current?.clear();
  };

  const handleSave = () => {
    if (signaturePadRef.current?.isEmpty()) {
      notify('Please provide a signature first.',{type:'warning',anchorOrigin: { vertical: 'top', horizontal: 'right' }});

    } else {
      const dataURL = signaturePadRef.current.toDataURL();
      // console.log(dataURL); // You can send this dataURL to your server or save it as an image
      // alert('Signature saved!');
      setSignatureImage('signatureImage',dataURL,{shouldValidate:true});
    }
  };

  return (
    <div style={{ width: '100%', maxWidth: '400px' }}>
      <div
        style={{
          border: '1px solid #000',
          boxSizing: 'border-box',
          height: 'clamp(150px, 45vw, 200px)',
          padding: '10px',
          width: '100%',
        }}
      >
        <canvas
          ref={canvasRef}
          style={{ display: 'block', height: '100%', touchAction: 'none', width: '100%' }}
        />
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '10px' }}>
        <button
          aria-label='Clear signature'
          onClick={handleClear}
          style={{
            background: '#fff',
            border: '1px solid #2dc3e8',
            borderRadius: '4px',
            color: '#2dc3e8',
            cursor: 'pointer',
            fontSize: '13px',
            minHeight: '36px',
            padding: '0 16px',
          }}
          type='button'
        >
          Clear
        </button>
        <button
          aria-label='Save signature'
          onClick={handleSave}
          style={{
            background: '#2dc3e8',
            border: '1px solid #2dc3e8',
            borderRadius: '4px',
            color: '#fff',
            cursor: 'pointer',
            fontSize: '13px',
            minHeight: '36px',
            padding: '0 16px',
          }}
          type='button'
        >
          Save
        </button>
      </div>
    </div>
  );
};


export default SignaturePadComponent;
